"use client"
import { location } from '@/services'
import { useQuery } from '@tanstack/react-query'

// ----------------------------------------------------------------------

type ReturnType = {
  dataCities: City[] | undefined
  isLoadingDataCitys: boolean
}

export function useCities(addressType: string): ReturnType {
  const { data: dataCities, isLoading: isLoadingDataCitys } = useQuery({
    queryKey: ['GET_DATA_CITYS', addressType],
    queryFn: async () => await location.listCities({ addressType: addressType }),
    staleTime: Infinity,
    retry: 0,
    enabled: !!addressType,
  })

  return {
    dataCities,
    isLoadingDataCitys,
  }
}

export function useOldCities() {
  const { data: dataCities, isLoading: isLoadingDataCitys } = useQuery({
    queryKey: ['GET_DATA_OLD_CITYS'],
    queryFn: async () => await location.listOldCities(),
    staleTime: Infinity,
    retry: 0,
  })

  return {
    dataCities,
    isLoadingDataCitys,
  }
}
